import type { QuestionData, QuestionModule, QuestionModuleData, PageModelData } from '@/domains/seek/types';
import type { AbstractModel } from '@patsnap/tahiti-core/common/model';

export const PageModel = Symbol('PageModel');

export interface PageModel extends AbstractModel<PageModelData> {
    updateQuestionData(question_id: string, getUpdateQuestionValue: (value: QuestionData) => QuestionData): void;
    updateModuleData(question_id: string, moduleName: QuestionModule, getUpdateModuleValue: (value: QuestionModuleData) => QuestionModuleData): void;
    getQuestionData(question_id: string): QuestionData | undefined;
    getModuleData(question_id: string, moduleName: QuestionModule): QuestionModuleData | undefined;
}
